module.exports = __webpack_public_path__ + "static/media/add_doc.24b98365.png";